
// AJAX PROGRESS BAR
(function () {
    
    function newGuid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

    var ajaxQueue = {};

    $(document).ajaxSend(function (event, jqXHR, ajaxOptions) {
        var id = newGuid();
        var $progress = $('#page-progress');
        $progress.css('display', 'block');


        if (ajaxOptions.xhrFields === undefined)
            ajaxOptions.xhrFields = {};

        ajaxOptions.xhrFields['ag_id'] = id;

        var timer = setTimeout(function () {
            AjaxHelpers.AgBlockUi();
        }, 3000);

        var queueData = { id: id, timer: timer };
        ajaxQueue[id] = queueData;
        console.log(ajaxOptions);

    });

    $(document).ajaxComplete(function (event, jqXHR, ajaxOptions) {
        var $progress = $('#page-progress');

        var id = ajaxOptions.xhrFields['ag_id'];
        ajaxQueue[id].timer = clearTimeout(ajaxQueue[id].timer);
        delete ajaxQueue[id];

        if (Object.keys(ajaxQueue).length === 0) {
            $.unblockUI();
            $progress.css('display', 'none');
        }
    });

    // STORE REQUEST URL IN REQUEST
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        jqXHR.originalUrl = originalOptions.url;
    });

    // HANDLE AJAX ERRORS
    $(document).ajaxError(function (event, jqXhr, ajaxSettings, thrownError) {
        if (!AjaxHelpers.HandleExpiredSession(jqXhr) && thrownError.length > 0)
            alert(thrownError);
    });

    $(document).ajaxSuccess(function (event, request, settings) {
        AjaxHelpers.HandleExpiredSession(request);
    });
})();

function AjaxHelpers() { }

$.AgBlockUi = function () { AjaxHelpers.AgBlockUi() }

AjaxHelpers.AgBlockUi = function () {
    $.blockUI({
        baseZ: 2000,
        message: '<div style="height:125px;width:125px;"><div class="cssload-spin-box"></div></div>',
        css: { width: '20%', left: '40%' }
    });
}

AjaxHelpers.GetUrlParam = function (name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp(name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

AjaxHelpers.NewGuid = function () {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

AjaxHelpers.HandleExpiredSession = function (request) {

    if (request.getResponseHeader('REQUIRES_AUTH') === '1') {
        window.location = window.location;
        return true;
    }
    return false;
}